import { createSlice } from "@reduxjs/toolkit";

export const CbtReducer = createSlice({
    name:"cbt",
    initialState:{cbts:[]},
    reducers:{
       setCbts:(state, action) => {
            //state.cbts = action.payload;
            return {
                cbts:action.payload
            };
       },
       addCbt:(state, action) => {
            return {
            cbts:[action.payload, ...state.cbts]
            };
      },
      deleteCbt:(state,action)=>{
        return{
            cbts:state.cbts.filter(eachCbt => eachCbt.id != action.payload.id)
        };
      },
      editCbt:(state,action)=>{
        const editedCbt = state.cbts.map(eachCbt => eachCbt.id == action.payload.id?action.payload:eachCbt)
        return{
            cbts:editedCbt,
        };
      },
      editCbtScore: (state, action) => {
        state.cbts.forEach(cbt => {
          if (cbt.id === action.payload.cbt.id) {
            cbt.users.forEach(user => {
              if (user.id === action.payload.id) {
                user.score = Number(action.payload.score)
              }
            });
          }
        })
      }
    }
})
export const {setCbts,addCbt,deleteCbt,editCb, editCbtScore} = CbtReducer.actions;
export default CbtReducer.reducer;